// Product assets uploaded by user
export const PRODUCT_IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/7rau9fta_717457049_2850094138689464_8681741335284965941_n.png",
  threeSteps: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/9lr8po3o_720814096_1241286244597942_8751932808760629021_n.png",
  refrigerant: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/cf53wgep_719968999_2450223642108892_5362258580200837221_n.png",
  specs: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/7rau9fta_717457049_2850094138689464_8681741335284965941_n.png",
  blueCup: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/e6p6s09p_718964232_874985659006065_199883802454559478_n.png",
  freezeFamily: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/fc5qa1q8_718237457_932436093185717_1450089729488238478_n.jpg",
  slushyFamily: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/qaol2e6x_717377045_1551389049660102_6866845961126555016_n.jpg",
};

// Alternative payment info for manual transfers
export const ALT_PAYMENTS = {
  paypal_email: "armaninino091@gmail.com",
  paypal_qr: "https://customer-assets.emergentagent.com/job_store-builder-helper/artifacts/8lgaetv9_720099855_2430755694060697_4242359511867734449_n.jpg",
  paypal_name: "Niño Armani",
  bizum: "667 088 343",
  iban: "ES00 4906 2265 2010 0367 09",
  account_holder: "Velora",
};
